import Level from '../core/level.js'
import questions from './commons/black_box_questions.js'

const level = new Level({
    name: 'black_box_simple',
    dependencies: []
})


for (let key in questions) {
    level.addQuestion(questions[key])
}


export default level

